import React, { HTMLAttributes } from "react";

import { StyledEntityGroup } from "./Styles";

export interface IEntityGroupProps
  extends Pick<
    HTMLAttributes<HTMLDivElement>,
    "className" | "style" | "children"
  > {
  gap?: number;
  renderAs?: "grid" | "list";
}

export interface IEntityGroupContext {
  renderAs: "grid" | "list";
}
export const EntityGroupContext = React.createContext<IEntityGroupContext>({
  renderAs: "grid",
});
export const EntityGroup: React.FC<IEntityGroupProps> = ({
  children,
  gap,
  renderAs = "grid",
  ...rest
}) => {
  return (
    <EntityGroupContext.Provider value={{ renderAs: renderAs }}>
      <StyledEntityGroup $renderAs={renderAs} $gap={gap} {...rest}>
        {children}
      </StyledEntityGroup>
    </EntityGroupContext.Provider>
  );
};

EntityGroup.displayName = "EntityGroup";
